<template>
  <v-container fluid>
    <div class="">
      <v-btn
        @click="$emit('edit-partner', 'partner-form', {})"
        class="mx-0 my-3"
        outline
        color="primary"
        v-if="amazeUserCan('administer', 'dsec_calendar')"
        ><v-icon class="pr-2" small>fa fa-plus</v-icon>Add Partner/Hub</v-btn
      >
    </div>
    <!-- DATA TABLE -->
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="sortedPartners"
      :pagination.sync="tablePagination"
      :loading="loading"
      :rows-per-page-items="rowsPerPage"
      sort-icon="arrow_drop_down"
      class="elevation-1 amaze-data-table"
    >
      <template slot="items" slot-scope="props">
        <td class="larger">{{ props.item.name }}</td>
        <td class="larger">
          <v-chip
            :class="'t-' + props.item.type"
            label
            small
            v-if="props.item.type"
            disabled
            >{{ props.item.type == "hub" ? "Hub" : "Partner" }}</v-chip
          >
        </td>
        <td class="larger">
          <a
            :href="props.item.program_reporting_url"
            target="_blank"
            rel="noopener"
            >{{ props.item.program_reporting_url }}</a
          >
        </td>
        <td class="larger">
          <a
            :href="props.item.program_data_url"
            target="_blank"
            rel="noopener"
            >{{ props.item.program_data_url }}</a
          >
        </td>
        <td class="text-right layout px-0 cardActions">
          <v-menu class="cardMenu hidden-md-and-up" bottom left>
            <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
            <v-list>
              <div v-if="amazeUserCan('administer', 'dsec_calendar')">
                <v-list-tile
                  v-on:click="$emit('edit-partner', 'partner-form', props.item)"
                >
                  <v-list-tile-title>Edit Partner</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="deletePartner(props.item)">
                  <v-list-tile-title>Delete Partner</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
          <v-tooltip top v-if="amazeUserCan('administer', 'dsec_calendar')">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  class="hidden-sm-and-down amaze-user-action"
                  slot="activator"
                  @click="$emit('edit-partner', 'partner-form', props.item)"
                  icon
                  ><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn
                >
              </div>
            </template>
            <span>Edit Partner</span>
          </v-tooltip>
          <v-tooltip top v-if="amazeUserCan('administer', 'dsec_calendar')">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  class="hidden-sm-and-down amaze-user-action"
                  slot="activator"
                  @click="deletePartner(props.item)"
                  icon
                  ><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn
                >
              </div>
            </template>
            <span>Delete Partner</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        <!-- <v-btn
            color="primary"
            @click="getUsersFromApi">Reset</v-btn> -->
      </template>
    </v-data-table>
    <!-- END DATA TABLE -->
    <div v-else>
      <div class="text-xs-center py-4">
        <h4>
          <v-icon class="mr-2">fas fa-circle-notch fa-spin</v-icon> Loading
        </h4>
      </div>
    </div>
  </v-container>
</template>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import _ from "lodash";
export default {
  mixins: [permissionsMixin],
  data() {
    return {
      partners: [],
      editPartnerObject: {},
      loading: false,
      headers: [
        { text: "Partner", value: "name", width: "30%" },
        { text: "Type", value: "type" },
        {
          text: "Program Data Reporting URL",
          value: "program_reporting_url",
          sortable: false
        },
        { text: "See My Data URL", value: "program_data_url", sortable: false },
        { text: "", value: null, sortable: false, align: "center" }
      ],
      tablePagination: {
        rowsPerPage: 15
      },
      rowsPerPage: [15]
    };
  },
  computed: {
    totalPartners() {
      return this.partners.length;
    },
    sortedPartners() {
      let sortBy = this.tablePagination.sortBy;
      let sortDir = this.tablePagination.descending ? -1 : 1;
      let sorted = this.partners.slice(0);

      if (sortBy) {
        sorted.sort((a, b) => {
          return a[sortBy].toUpperCase() < b[sortBy].toUpperCase()
            ? -1 * sortDir
            : 1 * sortDir;
        });
      }

      return sorted;
    }
  },
  methods: {
    newPartner() {
      this.editPartnerObject = {};
      this.partnerDialog = true;
    },
    editPartner(item) {
      this.editPartnerObject = item;
      this.ac_results = item.users;
      this.partnerDialog = true;
    },
    getPartners: _.debounce(async function () {
      this.loading = true;
      let partners = await this.$http.get("dsec/partners");
      this.partners = partners.body;
      this.loading = false;
    }, 500),
    async deletePartner(partner) {
      if (
        confirm(
          "Are you sure? All events associated with this partner will also be deleted."
        )
      ) {
        this.loading = true;
        let result = await this.$http.delete("dsec/partners/" + partner.id);
        if (result.status === 200) {
          this.getPartners();
        } else {
          console.log("[ERROR] Partner not deleted");
        }
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getPartners();
    EventBus.$on("refreshPartners", this.getPartners);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/dsec-labels.scss";
.v-btn--flat {
  font-weight: normal;
}
</style>
